import {computed} from 'vue';
import {useDataTracking} from '#imports';
import {useABTest, useFeatureFlag} from '@malt/feature-flags';

const UNIFIED_SEARCH_CAMPAIGN = 'keyword-search-unified-recipe';

export function useUnifiedSearchExperiment() {
    const isEnabled = useFeatureFlag(UNIFIED_SEARCH_CAMPAIGN);
    const {getVariationWithoutTracking} = useABTest();
    const {track} = useDataTracking();

    const variation = computed(() => getVariationWithoutTracking(UNIFIED_SEARCH_CAMPAIGN));
    const unifiedSearchEnabled = computed(() => isEnabled.value && variation.value === 'treatment');

    function trackUnifiedSearchExposure() {
        if (isEnabled.value && variation.value) {
            // eslint-disable-next-line @malt/tracking-event-name
            track('$exposure', {flag_key: UNIFIED_SEARCH_CAMPAIGN, variant: variation.value});
        }
    }

    return {unifiedSearchEnabled, trackUnifiedSearchExposure};
}
